// extracted by mini-css-extract-plugin
export default {"placeOrderContainer":"xW4FxZz4sW_Dkct7hCHo"};